import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  LinearProgress,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export default function ShiftMetrics({ data, onShiftClick }) {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));

  const shifts = data?.shiftWiseMetrics || [];

  const getProgressColor = (pct) => {
    if (pct >= 80) return "#4CAF50";
    if (pct >= 50) return "#FF9800";
    return "#F44336";
  };

  return (
    <Box
      sx={{
        background: "#fff",
        borderRadius: "16px",
        p: 2,
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        height: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography sx={{ fontWeight: 700, fontSize: "16px", color: "#333" }}>
          Shift-wise Metrics
        </Typography>
        <AccessTimeIcon sx={{ color: "#1565C0" }} />
      </Box>

      {shifts.length > 0 ? (
        <TableContainer sx={{ maxHeight: 350 }}>
          <Table size="small" stickyHeader>
            <TableHead sx={{ display: "table-header-group" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, fontSize: "12px" }}>
                  Shift
                </TableCell>
                {!isSmall && (
                  <TableCell sx={{ fontWeight: 600, fontSize: "12px" }}>
                    Time
                  </TableCell>
                )}
                <TableCell
                  align="center"
                  sx={{ fontWeight: 600, fontSize: "12px" }}
                >
                  Total
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: 600, fontSize: "12px" }}
                >
                  In
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ fontWeight: 600, fontSize: "12px" }}
                >
                  Out
                </TableCell>
                <TableCell
                  sx={{ fontWeight: 600, fontSize: "12px", minWidth: 140 }}
                >
                  Attendance %
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {shifts.map((s, i) => {
                const pct = s.attendancePercentage || 0;
                return (
                  <TableRow
                    key={i}
                    hover
                    onClick={() => onShiftClick && onShiftClick(s.shiftName)}
                    sx={{ cursor: "pointer" }}
                  >
                    <TableCell sx={{ fontSize: "12px", fontWeight: 500 }}>
                      {s.shiftName}
                    </TableCell>
                    {!isSmall && (
                      <TableCell sx={{ fontSize: "11px", color: "#666" }}>
                        {s.startTime && s.endTime
                          ? `${s.startTime} - ${s.endTime}`
                          : "—"}
                      </TableCell>
                    )}
                    <TableCell align="center" sx={{ fontSize: "12px" }}>
                      {s.totalEmployees}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontSize: "12px", color: "#2E7D32", fontWeight: 600 }}
                    >
                      {s.checkedIn}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontSize: "12px", color: "#D32F2F", fontWeight: 600 }}
                    >
                      {s.notCheckedIn}
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <LinearProgress
                          variant="determinate"
                          value={pct}
                          sx={{
                            flex: 1,
                            height: 8,
                            borderRadius: 4,
                            backgroundColor: "#f0f0f0",
                            "& .MuiLinearProgress-bar": {
                              borderRadius: 4,
                              backgroundColor: getProgressColor(pct),
                            },
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: "11px",
                            fontWeight: 600,
                            color: getProgressColor(pct),
                            minWidth: "35px",
                          }}
                        >
                          {pct}%
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Box sx={{ py: 4, textAlign: "center" }}>
          <AccessTimeIcon sx={{ fontSize: 40, color: "#ddd", mb: 1 }} />
          <Typography color="textSecondary">
            No shift data available for this date.
          </Typography>
        </Box>
      )}
    </Box>
  );
}
